import React from 'react';
import { useLinkedOrderNavigation } from './hooks';
import { OnwardBreadcrumbActive, OnwardBreadcrumbInactive, OnwardBreadcrumbSpacer } from '../Breadcrumbs';

/**
 * Linked-orders breadcrumb for the order details page: "My Orders", then each ancestor from the top of the family
 * down, then the current order. For example "My Orders > OD104409 > OD104409-1 > OD104409-1-A1", or
 * "My Orders > {order}" for a top-level or standalone order.
 *
 * "My Orders" returns to the list the user opened the first order from, however many linked orders they moved through
 * since. An ancestor crumb navigates to that order, which re-loads everything via the route param.
 *
 * @param {{ path: Array<{ order_id: string, order_number: string }> }} props `path` from buildLinkedOrdersTree, ending
 *   with the current order.
 */
const LinkedOrdersBreadcrumb = ({ path }) => {
    const { goToOrder, goBack } = useLinkedOrderNavigation();

    if (!path?.length) return null;
    const ancestors = path.slice(0, -1);
    const current = path[path.length - 1];

    return (
        <React.Fragment>
            <OnwardBreadcrumbInactive onClick={() => goBack()}>My Orders</OnwardBreadcrumbInactive>
            <OnwardBreadcrumbSpacer />
            {ancestors.map((o) => (
                <React.Fragment key={o.order_id}>
                    <OnwardBreadcrumbInactive onClick={() => goToOrder(o.order_id)}>
                        {o.order_number}
                    </OnwardBreadcrumbInactive>
                    <OnwardBreadcrumbSpacer />
                </React.Fragment>
            ))}
            <OnwardBreadcrumbActive>{current.order_number}</OnwardBreadcrumbActive>
        </React.Fragment>
    );
};

export default LinkedOrdersBreadcrumb;
